export default "__VITE_ASSET__$otD8zQA__"